(function () {
  'use strict';

  if (window.HNHomeHero) {
    window.HNHomeHero.init(document);
    return;
  }

  var selector = '[data-hn-home-hero]';
  var instances = new Map();

  function rootsWithin(scope) {
    var roots = scope.matches && scope.matches(selector) ? [scope] : [];
    return roots.concat(Array.from(scope.querySelectorAll(selector)));
  }

  function enhance(root) {
    if (instances.has(root)) return;
    var track = root.querySelector('[data-hn-hero-track]');
    if (!track) return;
    var cards = Array.from(track.querySelectorAll('[data-hn-hero-card]'));
    if (!cards.length) return;
    var previous = root.querySelector('[data-hn-hero-prev]');
    var next = root.querySelector('[data-hn-hero-next]');
    var controls = root.querySelector('[data-hn-hero-controls]');
    var status = root.querySelector('[data-hn-hero-status]');
    var saved = [];
    var frame = 0;
    var destroyed = false;
    var metrics;

    function remember(element, names) {
      if (!element) return;
      saved.push({ element: element, attributes: names.map(function (name) {
        return [name, element.getAttribute(name)];
      }) });
    }
    remember(track, ['tabindex', 'data-hn-hero-ready']);
    remember(controls, ['hidden']);
    remember(previous, ['hidden', 'disabled', 'aria-disabled', 'aria-label']);
    remember(next, ['hidden', 'disabled', 'aria-disabled', 'aria-label']);
    remember(status, ['hidden']);
    var originalStatus = status && status.textContent;
    if (!track.hasAttribute('tabindex')) track.tabIndex = 0;
    if (previous && !previous.hasAttribute('aria-label')) previous.setAttribute('aria-label', 'Previous categories');
    if (next && !next.hasAttribute('aria-label')) next.setAttribute('aria-label', 'Next categories');

    function measure() {
      var box = track.getBoundingClientRect();
      var left = box.left + track.clientLeft;
      var width = track.clientWidth || box.width;
      if (width <= 0) return null;
      var right = left + width;
      var rects = cards.map(function (card) { return card.getBoundingClientRect(); });
      if (!rects.some(function (rect) { return rect.width > 0; })) return null;
      var visible = [];
      var best = 0;
      var bestOverlap = -1;
      rects.forEach(function (rect, index) {
        var overlap = Math.max(0, Math.min(rect.right, right) - Math.max(rect.left, left));
        if (overlap > bestOverlap) { best = index; bestOverlap = overlap; }
        if (rect.width > 0 && overlap >= Math.min(rect.width, width) / 2 && overlap > 1) visible.push(index);
      });
      if (!visible.length) visible.push(best);
      var rtl = window.getComputedStyle(track).direction === 'rtl';
      return {
        left: left, right: right, rects: rects, rtl: rtl,
        first: visible[0], last: visible[visible.length - 1], count: visible.length,
        atStart: rtl ? rects[0].right <= right + 2 : rects[0].left >= left - 2,
        atEnd: rtl ? rects[rects.length - 1].left >= left - 2 : rects[rects.length - 1].right <= right + 2
      };
    }

    function setButton(button, disabled) {
      if (!button) return;
      button.hidden = false;
      button.disabled = disabled;
      button.setAttribute('aria-disabled', String(disabled));
    }

    function refresh() {
      frame = 0;
      if (destroyed) return;
      metrics = measure();
      if (!metrics) return;
      track.setAttribute('data-hn-hero-ready', '');
      if (controls) controls.hidden = false;
      setButton(previous, metrics.atStart);
      setButton(next, metrics.atEnd);
      if (status) {
        var first = metrics.first + 1;
        var last = metrics.last + 1;
        var text = first + (first === last ? '' : '\u2013' + last) + ' ' + (status.dataset.hnHeroOf || 'of') + ' ' + cards.length;
        if (status.textContent !== text) status.textContent = text;
        status.hidden = false;
      }
    }

    function schedule() {
      if (!destroyed && !frame) frame = window.requestAnimationFrame(refresh);
    }

    function goTo(index) {
      metrics = measure();
      if (!metrics) return;
      index = Math.max(0, Math.min(cards.length - 1, index));
      var rect = metrics.rects[index];
      var delta = metrics.rtl ? rect.right - metrics.right : rect.left - metrics.left;
      var reduced = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      var left = track.scrollLeft + delta;
      if (typeof track.scrollTo === 'function') track.scrollTo({ left: left, behavior: reduced ? 'auto' : 'smooth' });
      else track.scrollLeft = left;
      schedule();
    }

    function move(direction) {
      metrics = measure();
      if (!metrics || (direction < 0 ? metrics.atStart : metrics.atEnd)) return;
      goTo(metrics.first + direction * metrics.count);
    }
    function onPrevious() { move(-1); }
    function onNext() { move(1); }
    function onKey(event) {
      if (event.target !== track || event.altKey || event.ctrlKey || event.metaKey) return;
      var direction = window.getComputedStyle(track).direction === 'rtl' ? -1 : 1;
      if (event.key === 'ArrowLeft' || event.key === 'ArrowRight') {
        event.preventDefault();
        move((event.key === 'ArrowRight' ? 1 : -1) * direction);
      } else if (event.key === 'Home' || event.key === 'End') {
        event.preventDefault();
        goTo(event.key === 'Home' ? 0 : cards.length - 1);
      }
    }

    track.addEventListener('scroll', schedule, { passive: true });
    track.addEventListener('keydown', onKey);
    if (previous) previous.addEventListener('click', onPrevious);
    if (next) next.addEventListener('click', onNext);
    window.addEventListener('resize', schedule, { passive: true });
    var observer = typeof window.ResizeObserver === 'function' ? new window.ResizeObserver(schedule) : null;
    if (observer) {
      observer.observe(track);
      cards.forEach(function (card) { observer.observe(card); });
    }
    instances.set(root, function () {
      destroyed = true;
      if (frame) window.cancelAnimationFrame(frame);
      if (observer) observer.disconnect();
      track.removeEventListener('scroll', schedule);
      track.removeEventListener('keydown', onKey);
      if (previous) previous.removeEventListener('click', onPrevious);
      if (next) next.removeEventListener('click', onNext);
      window.removeEventListener('resize', schedule);
      saved.forEach(function (entry) {
        entry.attributes.forEach(function (attribute) {
          if (attribute[1] === null) entry.element.removeAttribute(attribute[0]);
          else entry.element.setAttribute(attribute[0], attribute[1]);
        });
      });
      if (status) status.textContent = originalStatus;
      instances.delete(root);
    });
    refresh();
  }

  function init(scope) { rootsWithin(scope || document).forEach(enhance); }
  function destroy(scope) {
    rootsWithin(scope || document).forEach(function (root) {
      var cleanup = instances.get(root);
      if (cleanup) cleanup();
    });
  }
  window.HNHomeHero = { init: init, destroy: destroy };
  document.addEventListener('shopify:section:load', function (event) { init(event.target); });
  document.addEventListener('shopify:section:unload', function (event) { destroy(event.target); });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { init(document); }, { once: true });
  else init(document);
}());
